import React from 'react'
import Filters from './Filters.js'
import { connect } from 'react-redux'
import { getCordingFabrics, getFabrics } from '../../actions/fabricsActions.js'
import { useParams } from 'react-router-dom'
import { scrollTo, sendGtag } from '../../utils/utils.js'

const FiltersView = (props) => {
  const { fabrics: fabricsObj, switchCurrentView, isStyle } = props
  const { filters, cordingFilters } = fabricsObj
  const params = useParams()

  const _cancelFilters = () => {
    if (isStyle) {
      sendGtag('cancel_mobile_filters_style')
    }
    else {
      sendGtag('cancel_mobile_filters_fabrics')
    }

    switchCurrentView()
  }

  const _applyFilters = () => {
    const { dispatch } = props

    if (isStyle) {
      sendGtag('apply_mobile_filters_style')
    }
    else {
      sendGtag('apply_mobile_filters_fabrics')
    }

    if (params?.style) {
      dispatch(getCordingFabrics(cordingFilters, false))
    } else if (params?.fabric) {
      dispatch(getFabrics(filters, false, 'search'))
    }
    if (window.innerWidth <= 1024) {
      setTimeout(() => {
        scrollTo('cushion-fabric-selector-container', 100)
      }, 100)
    }
    switchCurrentView()
  }

  return (
    <div className="filters-container designer-filters">
      <Filters />
      <div className="buttons-container">
        <div id="cancel-button" className="white-button" onClick={_cancelFilters}>
          CANCEL
        </div>
        <div id="apply-filters-button" className="green-button" onClick={_applyFilters}>
          APPLY FILTERS
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  fabrics: state.fabrics,
})

export default connect(mapStateToProps)(FiltersView)
